import { normalizeHostToWww } from "./canonicalUrl";

interface BuildSiteBaseUrlParams {
  channelData?: { domain?: string | null; slug?: string | null } | null;
  host?: string | null;
}

/**
 * Origem canônica do site publicado, sem barra final.
 *
 * O `domain` do canal tem prioridade sobre o host da request: um site com
 * domínio apontado pode ser servido pela pasta default do S3 e chegar com o
 * host do Autódromo.
 *
 * O host passa pelo mesmo `normalizeHostToWww` da canonical e do sitemap. A
 * regra de host é uma só na plataforma: a URL da entidade no JSON-LD é o
 * endereço que ela declara, e declarar um host diferente do que a canonical
 * aponta é dizer duas coisas sobre a mesma página.
 */
export function buildSiteOrigin({
  channelData,
  host,
}: BuildSiteBaseUrlParams): string | null {
  const source = channelData?.domain || host;
  if (!source) return null;

  const domain = normalizeHostToWww(source);
  if (!domain) return null;

  return `https://${domain}`;
}

/**
 * URL base do site, já com o prefixo do slug do canal quando o site mora sob um
 * domínio compartilhado. É a base de todos os links internos do site.
 */
export function buildSiteBaseUrl({
  channelData,
  host,
}: BuildSiteBaseUrlParams): string | null {
  const origin = buildSiteOrigin({ channelData, host });
  if (!origin) return null;

  const sitePrefix = channelData?.slug ? `/${channelData.slug}` : "";

  return `${origin}${sitePrefix}`;
}
